import { httpClient } from '@/modules/common/services/http/http-client';
import {
  IStatementListRequest,
  IStatementListResponse,
  ITransactionReportFilters
} from './reports-types';

const http = httpClient.withOptions({
  baseURL: `${process.env.VUE_APP_BFF_URL}/reports`
});

export function getTransactionsReport(
  filters: ITransactionReportFilters
): Promise<BlobPart> {
  return http.get(`/v1/account-transactions`, {
    params: filters,
    responseType: 'blob'
  });
}

export function getTransactionsList(
  filters: IStatementListRequest
): Promise<IStatementListResponse> {
  return http.get('/v1/account-transactions/list', { params: filters });
}
